export class ApiError extends Error {
  constructor(message, { status, code, fieldErrors, raw } = {}) {
    super(message || 'Request failed');
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.fieldErrors = fieldErrors;
    this.raw = raw;
  }
}

export const isAuthError = (error) =>
  error instanceof ApiError && (error.status === 401 || error.status === 403);

export const isRateLimitError = (error) =>
  error instanceof ApiError && error.status === 429;

